const SettingCards = ({ icon, title, subtitle, button }) => {
  return (
    <div className="setting-card">
     
      <div className="setting-card-left-item">
        <div className="setting-card-icon">{icon}</div>
        <div className="setting-card-content">
          <span className="setting-card-title">{title}</span>
          <span className="setting-card-subtitle">{subtitle}</span>
        </div>
      </div>

      <div className="setting-card-right-item">{button}</div>
    </div>
  );
};

export default SettingCards;
